import React from 'react';
import { useTranslation } from 'react-i18next';

/**
 * Selektor języka - wariant kompaktowy (PL / EN toggle).
 * Zapisuje wybór do localStorage przez i18next-browser-languagedetector.
 */
export default function LanguageSwitcher({ compact = true, style }) {
  const { i18n, t } = useTranslation();
  const current = (i18n.language || 'pl').slice(0, 2);

  const change = (lng) => {
    if (lng !== current) i18n.changeLanguage(lng);
  };

  if (compact) {
    // Wariant compact: PL | EN obok siebie
    return (
      <div
        role="group"
        aria-label={t('language.label')}
        style={{
          display: 'inline-flex',
          gap: 1,
          padding: 2,
          borderRadius: 8,
          background: 'var(--t-dim-bg)',
          border: '1px solid var(--t-line)',
          ...style,
        }}
      >
        {['pl', 'en'].map(lng => {
          const active = current === lng;
          return (
            <button
              key={lng}
              type="button"
              onClick={() => change(lng)}
              aria-pressed={active}
              aria-label={lng === 'pl' ? t('language.polish') : t('language.english')}
              style={{
                padding: '4px 10px',
                borderRadius: 6,
                border: 'none',
                background: active ? 'var(--t-sage)' : 'transparent',
                color: active ? 'var(--t-bg)' : 'var(--t-text-dim)',
                fontFamily: 'var(--t-mono)',
                fontSize: 10,
                letterSpacing: '.16em',
                textTransform: 'uppercase',
                fontWeight: 500,
                cursor: 'pointer',
                transition: 'background 200ms ease, color 200ms ease',
              }}
            >
              {lng}
            </button>
          );
        })}
      </div>
    );
  }

  // Wariant rozbudowany: lista w sekcji ustawień (do hub Profilu w przyszłości)
  return (
    <div style={style}>
      <div style={{
        fontFamily: 'var(--t-mono)',
        fontSize: 10,
        letterSpacing: '.22em',
        textTransform: 'uppercase',
        color: 'var(--t-text-dim)',
        marginBottom: 10,
      }}>{t('language.label')}</div>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
        {[
          { code: 'pl', label: t('language.polish') },
          { code: 'en', label: t('language.english') },
        ].map(({ code, label }) => {
          const active = current === code;
          return (
            <button
              key={code}
              type="button"
              onClick={() => change(code)}
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                padding: '12px 14px',
                borderRadius: 10,
                border: `1px solid ${active ? 'var(--t-sage)' : 'var(--t-line)'}`,
                background: active ? 'rgba(168, 196, 158, 0.08)' : 'transparent',
                color: 'var(--t-text)',
                fontSize: 14,
                cursor: 'pointer',
                fontFamily: 'var(--t-sans)',
              }}
            >
              <span>{label}</span>
              <span style={{
                fontFamily: 'var(--t-mono)',
                fontSize: 10,
                letterSpacing: '.16em',
                textTransform: 'uppercase',
                color: active ? 'var(--t-sage)' : 'var(--t-text-mute)',
              }}>{code}</span>
            </button>
          );
        })}
      </div>
    </div>
  );
}
